import React, { useEffect, useState } from "react";
import Login from "./Login";
import { loginAction } from "../actionCreators";
import { getFormValues } from "redux-form";
import { useDispatch, connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SUCCESS } from "../../common/constants/commonConstant";

const LoginContainer = ({ values }) => {
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loginInfo, loginError } = useSelector(({ loginReducer }) => ({
    loginInfo: loginReducer.loginInfo,
    loginError: loginReducer.loginError
  }));

  const onSubmit = e => {
    const { mbrId, password } = values;
    dispatch(loginAction({ mbrId, password }));
  };

  useEffect(() => {
    if (loginError !== null) {
      if (SUCCESS !== loginError.retCode) {
        setError(loginError.userMsg);
      }
      return;
    }

    if (loginInfo) {
      try {
        localStorage.setItem("token", loginInfo.token);
        localStorage.setItem("adminYn", loginInfo.adminYn);

        navigate("/");
      } catch (e) {
        console.log("localStorage is not working");
      }
    }
  }, [loginInfo, loginError, navigate]);

  useEffect(() => {
    setError(null);
  }, []);

  return <Login onSubmit={onSubmit} error={error}></Login>;
};

export default connect(state => ({
  values: getFormValues("loginForm")(state)
}))(LoginContainer);
